module.exports = __webpack_public_path__ + "static/media/underline.7398aee9.svg";